import { BrowserRouter } from 'react-router-dom';
import './App.css';
import Router from './routes';
import { ToastContainer } from 'react-toastify';
import { SocketProvider } from './services/socketContext';
import { CallProvider } from './services/callProviderContext';

function App() {
  return (
    <BrowserRouter>
      <SocketProvider>
        <CallProvider>
          <ToastContainer />
          <Router />

        </CallProvider>
      </SocketProvider>
    </BrowserRouter>
  );
}

export default App;
